import React, { useState } from "react";
import { BravoProvider } from "../../context/StateProvider";
import CountdownTimer from "../../components/Countdown/CountdownTimer";
import { NavBar } from "../../components/NavBar";
import { HomePage } from "../HomePage";
import { AboutUs } from "../AboutUS";
import { Party } from "../Party";
import { Element } from "react-scroll";
import { Festival } from "../Festival";
import { LineUp } from "../LineUp/LineUp";
import { LineUpCopy } from "../LineUp copy/LineUp";
import { LineUpCopy2 } from "../LineUp copy 2/LineUp";
import { LineUpCopy3 } from "../LineUp copy 3/LineUp";
import { Footer } from "../../components/Footer";
import moment from "moment";

const chapters = [
  {
    id: 0,
     label: (
      <>
        FAZA 1 <span className="text_label">- “Za tebe uvek biću tu” -</span>
      </>
    ),
    deadline: "2025-11-16T18:00:00+01:00",

  },
  {
    id: 1,
    label: (
      <>
        FAZA 2 <span className="text_label">- “Nova Godina kuca na vratima” -</span>
      </>
    ),
    deadline: "2025-12-10T00:00:00+01:00",
    // text: (
    //   <>
    //     <strong>Chapter 1</strong> – ‘Down The Rabbit Hole’ pre-sale prodaja počinje{" "}
    //     <strong>11. jula u 18:00h</strong> i biće dostupna po specijalnim cenama samo
    //     registrovanima.
    //   </>
    // ),
  },
  {
    id: 2,
    label: (
      <>
        FAZA 3 <span className="text_label">- “Ponoć je ljube se svi” -</span>
      </>
    ),
    deadline: "2025-12-31T15:00:00+01:00",
    // text: (
    //   <>
    //     <strong>Chapter 2</strong> – ‘The Pool of Tears’ pre-sale prodaja počinje od 
    //     <strong>17. jula u 12:00</strong> i prodavaće se po drugim cenama. ⏱️🐇
    //   </>
    // ),
  },
  {
    id: 3,
    label: (
      <>
        {/* Chapter 3 <span className="text_label">- “Advice from the Caterpillar” -</span> */}
                ponoć je ljube se svi 

      </>
    ),
    // deadline: "2025-012-31 12:00:00",
    text: (
      <>
        <strong>SREĆNA NOVA GODINA! 
VOLI VAS DRAGI BRAVO ♥️</strong>
      </>
    ),
  },
  // {
  //   id: 4,
  //   label: (
  //     <>
  //       Chapter 4 <span className="text_label">- “The Queen's Croquet Ground” -</span>
  //     </>
  //   ),
  //   deadline: "2025-09-11T00:00:00+01:00",
  //   text: (
  //     <>
  //       <strong>Chapter 4</strong>: TEA PARTY od 1. septembra do početka festivala
  //     </>
  //   ),
  // },
];

function getCurrentAndNextChapters(chapters, now) {
  // Find current
  let currentIndex = chapters.findIndex((c, i) => {
    const start = moment(c.start);
    const end = moment(c.deadline);
    return now.isSameOrAfter(start) && now.isBefore(end);
  });

  // Ako nije pronađen, vrati poslednji
  if (currentIndex === -1) {
    // Ako je prošlo sve, vrati poslednji
    if (now.isSameOrAfter(moment(chapters[chapters.length - 1].deadline))) {
      return [chapters[chapters.length - 1]];
    }
    // Ako je pre početka, vrati prva dva
    return [chapters[0], chapters[1]];
  }

  // Ako postoji sledeći, vrati oba, inače samo trenutni
  if (currentIndex < chapters.length - 1) {
    return [chapters[currentIndex], chapters[currentIndex + 1]];
  }
  return [chapters[currentIndex]];
}

export const Home = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [modal, setModal] = useState(false);

  const now = moment();
  const chaptersToShow = getCurrentAndNextChapters(chapters, now);
  const currentChapter = chaptersToShow[0];
  const deadline = currentChapter.deadline;
  const line = now > moment(deadline);

  return (
    <BravoProvider>
      <div>
        <CountdownTimer deadline={deadline} line={line} chapters={chaptersToShow} />
        <NavBar isViewerOpen={isViewerOpen} modal={modal} setModal={setModal} />
        <Element name="home">
          <HomePage chapters={chaptersToShow} />
        </Element>
        <AboutUs isViewerOpen={isViewerOpen} />
        <Party isViewerOpen={isViewerOpen} setIsViewerOpen={setIsViewerOpen} />
        <Element name="festival">
          <Festival isViewerOpen={isViewerOpen} />
        </Element>
        {/* <Element name="lineup">
          <LineUp isViewerOpen={isViewerOpen} />
        </Element>
        <Element name="lineup">
          <LineUpCopy isViewerOpen={isViewerOpen} />
        </Element>
         <Element name="lineup">
          <LineUpCopy2 isViewerOpen={isViewerOpen} />
        </Element>
           <Element name="lineup">
          <LineUpCopy3 isViewerOpen={isViewerOpen} />
        </Element> */}
        <Footer modal={modal} setModal={setModal} />
      </div>
    </BravoProvider>
  );
};
